// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"35a9d58e","643":"d7edecbe"}[chunkId] + ".chunk.js";
};